/**
 * <details>の閉じるボタンを管理
 *
 * 仕様
 * - ist-js__detailClose: クリックで親details要素を閉じるボタン
 *
 * 使い方
 * <details>
 *   <summary>開閉ボタン</summary>
 *   コンテンツ
 *   <button class="ist-js__detailClose">閉じる</button>
 * </details>
 */

import {
  DetailAnimationManager,
  DetailAnimation,
} from '../detailsAnimation/_detailsAnimation';

/**
 * 1つのdetails閉じるボタンを管理するクラス
 */
export class DetailClose {
  private closeButton: HTMLElement;
  private parentDetails: HTMLDetailsElement | null;
  private detailAnimation: DetailAnimation | null = null;

  constructor(closeButton: HTMLElement) {
    this.closeButton = closeButton;
    this.parentDetails = this.closeButton.closest('details');
    this.init();
  }

  private init(): void {
    if (!this.parentDetails) return;

    this.detailAnimation = DetailAnimationManager.getInstance().findAnimation(
      this.parentDetails
    );
    this.closeButton.addEventListener('click', this.handleClick.bind(this));
  }

  private handleClick = (event: Event): void => {
    event.preventDefault();
    event.stopPropagation();
    this.close();
  };

  private close(): void {
    if (!this.parentDetails) return;

    if (this.detailAnimation) {
      this.detailAnimation.closeWithAnimation();
    } else {
      this.parentDetails.open = false;
    }

    const summary = this.parentDetails.querySelector('summary');
    if (summary) {
      summary.focus();
    }
  }

  public destroy(): void {
    this.closeButton.removeEventListener('click', this.handleClick);
  }
}

/**
 * 複数のdetails閉じるボタンを管理するマネージャークラス
 */
export class DetailCloseManager {
  private detailCloses: DetailClose[] = [];

  constructor() {
    this.init();
  }

  private init(): void {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.initializeDetailCloses();
      });
    } else {
      this.initializeDetailCloses();
    }
  }

  private initializeDetailCloses(): void {
    const closeButtons = document.querySelectorAll('.ist-js__detailClose');
    closeButtons.forEach((button) => {
      this.detailCloses.push(new DetailClose(button as HTMLElement));
    });
  }

  public getDetailCloses(): DetailClose[] {
    return this.detailCloses;
  }

  public destroy(): void {
    this.detailCloses.forEach((detailClose) => detailClose.destroy());
    this.detailCloses = [];
  }
}
